import StickyBottomButton from '../../common/StickyBottomButtonSave/StickyBottomButton';
import { Button } from '@material-ui/core';

import { themeButtons } from '../../../css/themeButtons';

const PhotoStickyBottomButton = ({
  userRole,
  orderedPhoto,
  tempAproovedPhoto,
  tempDisaproovedPhoto,
  clickButtonHandler,
}) => {
  const buttons = themeButtons();

  const bottomButtons = [
    {
      label: 'Сохранить',
      action: 'save',
      disabled: !!tempAproovedPhoto.length || !!tempDisaproovedPhoto.length,
      className: `btn ${buttons.btnGreen}`,
      visible: true,
    },
    {
      label: 'Отказать',
      action: 'reject',
      disabled: !tempAproovedPhoto.length,
      className: `btn ${buttons.btnWarn}`,
      visible: userRole === 'MODERATOR',
    },
    {
      label: 'Удалить',
      action: 'delete',
      disabled: !tempAproovedPhoto.length && !tempDisaproovedPhoto.length,
      className: `btn ${buttons.btnDanger}`,
      visible: true,
    },
    {
      label: 'Опубликовать',
      action: 'resolve',
      disabled: !tempDisaproovedPhoto.length,
      className: `btn ${buttons.btnGreen}`,
      visible: userRole === 'MODERATOR',
    },
  ];

  return (
    <StickyBottomButton>
      {bottomButtons.map((item) =>
        item.visible ? (
          <Button
            key={item.label}
            onClick={() => {
              clickButtonHandler(item.action);
            }}
            disabled={item.disabled}
            className={item.className}
            style={{ marginRight: '0.5rem' }}
          >
            {item.label}
          </Button>
        ) : null
      )}
    </StickyBottomButton>
  );
};

export default PhotoStickyBottomButton;
